__turbopack_context__.v({
  "bold": "DiwaliPopup-module__lcsa9q__bold",
  "cta": "DiwaliPopup-module__lcsa9q__cta",
  "imageContainer": "DiwaliPopup-module__lcsa9q__imageContainer",
  "root": "DiwaliPopup-module__lcsa9q__root",
  "textContainer": "DiwaliPopup-module__lcsa9q__textContainer",
});
